import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import { PasswordStrength } from 'ui/atoms/strength-indicator';
import Section from 'ui/atoms/section';
import { CreateAccountForm } from 'libraries/wizard/components/account-setup/create-account/helpers';
import Header from 'ui/atoms/header';
import { handleError } from 'src/ui/helper/error-handling';
import useTranslate from 'src/ui/hooks/use-translate';
import ServerError from 'src/ui/types/server-error';

export interface AccountCredentialsProps {
  shouldValidateEmail?: boolean;
  passwordStrength?: PasswordStrength | undefined;
  error?: ServerError;
}

const AccountCredentials: FunctionComponent<AccountCredentialsProps> = ({
  shouldValidateEmail,
  passwordStrength,
  error,
}) => {
  const { getErrorForField: getUniqueEmailError } = handleError({
    error,
    translate: useTranslate(),
    specialCodes: {
      email_already_used: {
        field: 'email',
        translateKey: 'errors.emailAlreadyUsed',
      },
    },
  });

  return (
    <Section>
      <Header size="small">
        <Translate name="createAccount.accountCredentials.headline" />
      </Header>
      <CreateAccountForm.Group name="email" required={true} fieldError={getUniqueEmailError('email')}>
        <CreateAccountForm.Input disabled={!shouldValidateEmail} />
        {shouldValidateEmail && CreateAccountForm.Validators.Email()}
      </CreateAccountForm.Group>
      <CreateAccountForm.PasswordGroup
        passwordField={{
          name: 'password',
        }}
        passwordRepeatField={{
          name: 'passwordRepeat',
        }}
        passwordStrength={passwordStrength}
      />
    </Section>
  );
};

export default AccountCredentials;
